import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩漫在线观看`}
          title={`${comic.title} - 最新高清免费韩国漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
          {comic.isHot && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              新作
            </span>
          )}
          {comic.status === '已完结' && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-secondary-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              完结
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-white text-xs truncate">{comic.description.slice(0, 40)}...</p>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
        {comic.title}
      </h3>
      <div className="flex items-center gap-3 mt-1">
        <span className="text-xs text-foreground-500">{comic.author}</span>
        <span className="text-xs text-foreground-400 flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          {comic.rating}
        </span>
      </div>
    </Link>
  );
}